// extracted by mini-css-extract-plugin
export default {"mainBg":"#f7f7f7","doHyeonFont":"'Do Hyeon', sans-serif","app":"app_app__55ZC+"};